import type {GameV1Config} from '@gongxigames/framework/slot/types/GameV1Config';
import type {SlotGameConfig} from '@gongxigames/framework/slot/types/SlotGameConfig';
import type {GameProvider, AreaSizeByOrientation} from '@gongxigames/framework/slotV2/types';

export type GameConfig = SlotGameConfig & GameV1Config & {
    gameProvider?: GameProvider;

    /**
     * Name of the ui layout.
     * Should be a name from the pre configured [[UILayout]]
     * TODO: multiple layouts
    */
    uiLayoutName?: string;
    gameAreaSize?: AreaSizeByOrientation;
};
